import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import Text from 'core/elements/Text'
import colors from 'core/themes/base/colors'
import Theme from 'core/themes/model'
import { hexToRgbaCss } from 'core/utils/colorHelpers'

interface Props {
  currentVersion?: string
  targetVersion?: string
  status?: 'ok' | 'fail' | 'loading'
}

const TimelineWithStatus = ({
  currentVersion = '',
  targetVersion = '',
  status = 'loading',
}: Props) => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <div className={classes.line}></div>
      <div className={classes.point}>
        <Text className={classes.label} variant="body2">
          {currentVersion}
        </Text>
      </div>
      <div
        className={clsx(classes.targetDottedLine, {
          [classes.targetDottedLineOk]: status === 'ok',
          [classes.targetDottedLineFail]: status === 'fail',
          [classes.targetDottedLineLoading]: status === 'loading',
        })}
      ></div>
      <div
        className={clsx(classes.targetPoint, {
          [classes.targetPointOk]: status === 'ok',
          [classes.targetPointFail]: status === 'fail',
          [classes.targetPointLoading]: status === 'loading',
        })}
      >
        <Text className={classes.label} variant="body2">
          {targetVersion}
        </Text>
      </div>
      <div className={classes.dottedLine}></div>
      <div className={classes.arrow}></div>
    </div>
  )
}

export default TimelineWithStatus
const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
    marginTop: theme.spacing(5),
  },
  line: {
    background: theme.palette.blue[700],
    height: 2,
    width: '100%',
  },
  point: {
    background: theme.palette.blue[700],
    width: 25,
    height: 8,
    borderRadius: '50%',
    position: 'relative',
    boxShadow: `0 0 0 4px ${hexToRgbaCss(theme.palette.blue['700'], 0.1)}`,
  },
  targetPoint: {
    borderRadius: '50%',
    position: 'relative',
  },
  targetPointOk: {
    width: 25,
    height: 8,
    background: colors.teal[100],
    border: 'none',
    boxShadow: `0 0 0 4px ${hexToRgbaCss(colors.teal[100], 0.1)}`,
  },
  targetPointFail: {
    width: 25,
    height: 8,
    background: colors.pink[800],
    border: 'none',
    boxShadow: `0 0 0 4px ${hexToRgbaCss(colors.pink[800], 0.1)}`,
  },
  targetPointLoading: {
    width: 20,
    height: 6,
    background: theme.palette.common.white,
    border: `2px solid ${theme.palette.blue[700]}`,
    boxShadow: 'none',
  },
  label: {
    bottom: '15px',
    position: 'absolute',
    right: '-15px',
  },
  dottedLine: {
    background: `repeating-linear-gradient(to right,${theme.palette.grey['500']} 0,${theme.palette.grey['500']} 10px,transparent 10px,transparent 16px)`,
    height: 2,
    width: '100%',
  },
  targetDottedLine: {
    height: 2,
    width: '100%',
  },
  targetDottedLineOk: {
    background: colors.teal[100],
  },
  targetDottedLineFail: {
    background: colors.pink[800],
  },
  targetDottedLineLoading: {
    background: `repeating-linear-gradient(to right,${theme.palette.blue['700']} 0,${theme.palette.blue['700']} 10px,transparent 10px,transparent 16px)`,
  },
  arrow: {
    transform: 'rotate(-45deg)',
    borderColor: theme.palette.blue[700],
    borderStyle: 'solid',
    borderWidth: '0 1px 1px 0',
    padding: '3px',
    position: 'absolute',
    right: '0px',
    bottom: '-3px',
  },
}))
